<template>
    <OperativeTable :dense="dense">
        <tbody>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici di struttura finanziaria</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF1">Elasticità degli impieghi</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF2">Liquidità del capitale investito</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF3">Rigidità dei finanziamenti</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF4">Indebitamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF5">Solidità patrimoniale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SSF" strong>Scoring struttura finanziaria</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici di ciclo finanziario</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ICF1">Rotazione del capitale investito</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SCF" strong>Scoring ciclo finanziario</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici dell'andamento economici</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE1">ROS</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE2">ROI</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE3">ROE</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE4">Tasso di indebitamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SAE" strong>Scoring andamento economico</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Leverage</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.L1">Leverage</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SL" strong>Scoring leverage</OperativeTableBodyRowKpi>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />

        <OperativeTableSectionTitle :years="yearsTableHeadings">Analisi di equilibrio della struttura aziendale</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA1">Liquidità</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA2">Disponibilità</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA3">Garanzia</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA4">Margine di tesoreria</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA5">Capitale di circolante netto</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA6">Margine di struttura</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SESA" strong>Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />

        <OperativeTableSectionTitle :years="yearsTableHeadings">Z-Score - Probabilità di fallimento entro 2 anni</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS1">Indice di flessibilità aziendale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS2">Indice di autofinanziamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS3">ROI</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS4">Indice di indipendenza da terzi</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS5">Turnover attività</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpiZScore :values="yearsTableRows.ZS" strong>Z-Score</OperativeTableBodyRowKpiZScore>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />
        <OperativeTableSectionTitle :years="yearsTableHeadings">Rating</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRow :values="yearsTableRows.R1">
          Grado di copertura delle immobilizzazioni nette
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="yearsTableRows.R2">
          Grado di indipendenza finanziaria
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="yearsTableRows.R3">
          Indice oneri finanziari su fatturato
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="yearsTableRows.R4">
          Liquidità generata dalla gestione
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRowKpiRating :values="yearsTableRows.R" strong>Rating</OperativeTableBodyRowKpiRating>
        </tbody>
      </OperativeTable>
</template>
<script>

import operativePageMixin from '../../../../mixins/operativePage';
import loadingDataMixin from '../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../mixins/computedFinancialData';

export default {
  name: 'page-operative-company-kpi',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin],
  components: {
    OperativeTableSectionTitle: () => import('../../../components/Operative/OperativeTableSectionTitle'),
    OperativeTable: () => import('../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../components/Operative/OperativeTableBodyRow'),
    OperativeTableBodyRowKpi: () => import('../../../components/Operative/Kpi/OperativeTableBodyRowKpi'),
    OperativeTableBodyRowKpiZScore: () => import('../../../components/Operative/Kpi/OperativeTableBodyRowKpiZScore'),
    OperativeTableBodyRowKpiRating: () => import('../../../components/Operative/Kpi/OperativeTableBodyRowKpiRating'),
    OperativeTableEmptyBodyRow: () => import('../../../components/Operative/OperativeTableEmptyBodyRow'),
  },
  props: {
    yearsTableRows: {
      default: null,
      type: Object,
    },
    yearsTableHeadings: {
      default: null,
      type: Array,
    },
    dense: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.page-operative-kpi {
  .operative-table-body-header {
    .operative-table-value-column-header {
      text-align: left;
    }
  }
}
</style>
